import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import ComponentRowRender from '../../../../../../baseComponents/ComponentRowRender'
import CRRBody from '../../../../../../baseComponents/ComponentRowRender/CRRBody'
import { ComponentRowRenderSchema } from '../../../../../../baseComponents/ComponentRowRender/types'
import NullComponent from '../../../../../../baseComponents/NullComponent'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { usePlainMeasureDictionary } from '../../../../../../utils/hooks/useMeasureDictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getAllProductTypes, getConfigParam } from '../../../../../../utils/reducers/getters'
import { ITDisplayNumber, ITDisplayPrice, ITDisplayVat, ITDisplayPriceNotRounded } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { calculateColumnWidth } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/functions'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { SwitchButton } from '../../../../../../baseComponents/Button/SwitchButton'
import { FooterOrderTotalWithAccountsTabs } from './types'
import { FooterTotalsResult, HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { ProductTypesPayload } from '../../../../../../utils/reducers/products/productTypes'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { OnChangeOrderTableLogicProps } from '../../OrderTable/useOrderTableHooks'
import { UserPermissionsSingle } from '../../../../../../baseComponents/CreateRoutering/types'
import { OrderHeaderURLs } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import FooterOrderRightComponent from './Components/FooterOrderRightComponent'
import FooterOrderLeftComponent, { FooterConfigShippingComponentBaseProps } from './Components/FooterOrderLeftComponent'

interface RowRendererTotalsBaseProps {
    totalsOrderTableData: FooterTotalsResult
    CurrencyId: string
    costs: TwinDictionary
}

interface RowRendererTotalsFullProps extends RowRendererTotalsBaseProps {
    headerDataCalculate: HeaderDataCalculate
}

interface FooterOrderTotalProps extends RowRendererTotalsFullProps {}

const FooterOrderTotal: React.FC<FooterOrderTotalProps> = ({ headerDataCalculate, costs, ...rest }) => {
    return (
        <div className='mt-20 input_table_footer_footer'>
            {headerDataCalculate?.OrderAccounts?.length ?
                <FooterOrderTotalWithAccounts {...{ headerDataCalculate, costs, ...rest }} />
                :
                <RowRendererOrderTotalWithoutAcc {...{ headerDataCalculate, costs, ...rest }} />
            }
        </div>
    )
}
interface RowRendererOrderTotalWithoutAccProps extends RowRendererTotalsBaseProps{
}
export const RowRendererOrderTotalWithoutAcc: React.FC<RowRendererOrderTotalWithoutAccProps> = ({ totalsOrderTableData, CurrencyId, costs }) => {
    const { t } = useTwinTranslation()
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    const firstColumns: ComponentRowRenderSchema<FooterTotalsResult['vat']> = []
    const beforeSubtotalAfterColumns: ComponentRowRenderSchema<FooterTotalsResult['vat']> = []
    let beforeTotalColumns: ComponentRowRenderSchema<FooterTotalsResult['vat']> = []
    const myData: TwinDictionary = {}
    const measures: any = usePlainMeasureDictionary()
    const productTypes = getAllProductTypes()
    let haveDescription = false
    let total = 1
    const childrens: {[vatId: string]: FooterTotalsResult['vat']} = {}
    for (const key in totalsOrderTableData.vat) {
        const myVat = totalsOrderTableData.vat[key]
        let myChildrenKey =  myVat.taxUsed + '-' + (myVat.taxUsed2 || '0')
        if (key.includes('FINANCIAL_RECHARGE')) {
            continue
        }
        if (!childrens[myChildrenKey]){
            childrens[myChildrenKey] = {}
        }
        childrens[myChildrenKey][key] = totalsOrderTableData.vat[key]
        if (key.includes('COST')) {
            const [id] = key.split('COST')
            if (id) {
                childrens[myChildrenKey][key].name = costs?.[parseInt(id)]?.name
                haveDescription = true
            }
        } else if (key.includes('SHIPPING')) {
            childrens[myChildrenKey][key].name = t('shipping', 'Transporte')
            haveDescription = true
        } else if (key.includes('productTypeId')) {
            const splitted = key?.split(':')
            const ProductTypeId = splitted?.[splitted?.length-1]
            childrens[myChildrenKey][key].name = productTypes?.[ProductTypeId]?.name || ''
            haveDescription = true
        }else {
            childrens[myChildrenKey][key].name = t('products', 'Productos')
            haveDescription = true
        }
    }
    for (const key in totalsOrderTableData.groupByVat) {
        myData[key] = totalsOrderTableData.groupByVat[key]
        if (key.includes('FINANCIAL_RECHARGE')) {
            myData[key].name = t('financialRechargeShort', 'Recargo Fin.')
            haveDescription = true
        }else{
            myData[key].name = t('base', 'Base') + ' ' + total
            haveDescription = true
            total++
            if (childrens[key]){
                myData[key].childrens = childrens[key]
            }
        }
    }
    if (haveDescription) {
        firstColumns.push(
            {
                label: <span className={'medium16'}>{t('description', 'Descripción')}</span>,
                dataKey: 'name',
                customRender: (value) => {
                    return value
                },
                width: 95 + (totalsOrderTableData.totals.subTotalCosts.toFixed(decimals).length * 8)
            },
        )
    }
    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measures[unit]
        firstColumns.push(
            {
                label: <span className={'medium16'}>{label}</span>,
                dataKey: 'units',
                customRender: (value) => <ITDisplayNumber value={value[unit] ? value[unit] : ''} />,
                width: 68 + (totalsOrderTableData.totals.units[unit].toFixed(decimals).length * 4)
            },
        )
    }
    if (totalsOrderTableData.totals.discounts_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <OrderSingleHeaderRR transKey='discounts' translation='Descuentos' />,
                dataKey: 'discounts_before',
                customRender: (value, allValues) => <ITDisplayPrice value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 80 + (totalsOrderTableData.totals.discounts_before.toFixed(decimals).length * 5)
            },
        )
    }
    if (totalsOrderTableData.totals.recharge_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <OrderSingleHeaderRR transKey='recharges' translation='Recargos' />,
                dataKey: 'recharge_before',
                customRender: (value, allValues) => <ITDisplayPrice value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 50 + (totalsOrderTableData.totals.recharge_before.toFixed(decimals).length * 8)
            },
        )
    }
    if (totalsOrderTableData.totals.vatMoney2) {
        beforeTotalColumns = [
            {
                label: <OrderSingleHeaderRR transKey='recharge' translation='Recargo' />,
                dataKey: 'taxUsed2',
                customRender: (value) => <ITDisplayVat {...{ value }} />,
                width: 80
            },
            {
                label: <OrderSingleHeaderRR transKey='rechargeImp' translation='Imp. Recargo' />,
                dataKey: 'vatMoney2',
                customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 105 + (totalsOrderTableData.totals.vatMoney2.toFixed(decimals).length * 1.5)
            }
        ]
    }
    const columns: ComponentRowRenderSchema<FooterTotalsResult['vat']> = [
        ...firstColumns,
        {
            label: <OrderSingleHeaderRR transKey='subtotal' translation='Subtotal' />,
            dataKey: 'subtotal',
            customRender: (value, allValues) => value === 0 ? <NullComponent /> : <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 50 + (totalsOrderTableData.totals.subtotal.toFixed(decimals).length * 7.5)
        },
        ...beforeSubtotalAfterColumns,
        {
            label: <OrderSingleHeaderRR transKey='totalWithoutVat' translation='Base imponible' />,
            dataKey: 'subTotalAfter',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 115 + (totalsOrderTableData.totals.subTotalAfter.toFixed(decimals).length * 2)
        },
        {
            label: <OrderSingleHeaderRR transKey='vat' translation='Impuesto' />,
            dataKey: 'taxUsed',
            customRender: (value) => <ITDisplayVat {...{ value }} />,
            width: 85
        },
        {
            label: <OrderSingleHeaderRR transKey='totalVat' translation='Total Impuestos' />,
            dataKey: 'vatMoney',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 117 + (totalsOrderTableData.totals.vatMoney.toFixed(decimals).length * 2)
        },
        ...beforeTotalColumns,
        {
            label: <OrderSingleHeaderRR transKey='total' translation='Total' />,
            dataKey: 'total',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 75 + (totalsOrderTableData.totals.total.toFixed(decimals).length * 5.5),
            className: 'mr-30'
        },
    ]
    const { columnWidth, ref } = useRowRendererFooterOrderTotalLogic({ columns })
    return (
        <div className='overflow-x-auto flex flex-col flex-auto pt-8 mt-5 row_renderer_totals_parent ' ref={ref}>
            <ComponentRowRender columns={columns} data={{ ...myData }} />
            <div className='w-full input_table_footer_total flex'>
                <CRRBody columns={columns} data={[totalsOrderTableData.totals]} defaultColumnWidth={columnWidth} />
            </div>
        </div>
    )
}

interface FooterOrderTotalWithAccountsProps extends RowRendererTotalsFullProps { }

const FooterOrderTotalWithAccounts: React.FC<FooterOrderTotalWithAccountsProps> = ({ totalsOrderTableData, CurrencyId, headerDataCalculate, costs }) => {
    const items: FooterOrderTotalWithAccountsTabs[] = [
        {
            element: <TwinTrans transKey={'totalsWithoutVat'}>Bases imponibles</TwinTrans>,
            component: RowRendererOrderTotalWithoutAcc
        },
        {
            element: <TwinTrans transKey={'byChapters'}>Por capítulos</TwinTrans>,
            component: RowRendererTotalsByAccount
        },
    ]

    const { tabIndex, setTabIndex } = useFooterOrderTotalWithAccountsLogic()
    const MyComponent = items[tabIndex].component
    return (
        <div>
            <SwitchButton className='w-fit ml-auto switch_footer_order_totals' onClick={setTabIndex} active={tabIndex} items={items} />
            <MyComponent totalsOrderTableData={totalsOrderTableData} CurrencyId={CurrencyId} headerDataCalculate={headerDataCalculate} costs={costs}/>
        </div>
    )
}

const useFooterOrderTotalWithAccountsLogic = () => {
    const [tabIndex, setTabIndex] = useState<number>(0)
    return { tabIndex, setTabIndex }
}

interface RowRendererTotalsByAccountProps extends RowRendererTotalsFullProps {}

export const RowRendererTotalsByAccount: React.FC<RowRendererTotalsByAccountProps> = ({ totalsOrderTableData, CurrencyId, headerDataCalculate }) => {
    const { t } = useTwinTranslation()
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    const firstColumns: ComponentRowRenderSchema<FooterTotalsResult['groupByAccount']> = []
    const beforeSubtotalAfterColumns: ComponentRowRenderSchema<FooterTotalsResult['groupByAccount']> = []
    let beforeTotalColumns: ComponentRowRenderSchema<FooterTotalsResult['groupByAccount']> = []
    const myData: TwinDictionary = totalsOrderTableData.groupByAccount
    const measures: any = usePlainMeasureDictionary()
    const allMyAccounts = headerDataCalculate?.OrderAccounts
    for (const account of allMyAccounts || []) {
        if (account.name !== '--other') {
            myData[account.id]['name'] = account.name || ''
        }
    }
    if (myData['--other']) {
        myData['--other']['name'] = t('rest', 'Resto')
    }
    firstColumns.push(
        {
            label: <span className={'medium16'}>{t('description', 'Descripción')}</span>,
            dataKey: 'name',
            customRender: (value) => {
                return value
            },
            width: 95 + (totalsOrderTableData.totals.subTotalCosts?.toFixed(decimals).length * 8)
        },
    )
    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measures[unit]
        firstColumns.push(
            {
                label: <span className={'medium16'}>{label}</span>,
                dataKey: 'units',
                customRender: (value) => <ITDisplayNumber value={value?.[unit] ? value[unit] : ''} />,
                width: 68 + (totalsOrderTableData.totals.units[unit].toFixed(decimals).length * 4)
            },
        )
    }
    if (totalsOrderTableData.totals.discounts_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <OrderSingleHeaderRR transKey='discounts' translation='Descuentos' />,
                dataKey: 'discounts_before',
                customRender: (value, allValues) => <ITDisplayPrice value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 80 + (totalsOrderTableData.totals.discounts_before.toFixed(decimals).length * 5)
            },
        )
    }
    if (totalsOrderTableData.totals.recharge_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <OrderSingleHeaderRR transKey='recharges' translation='Recargos' />,
                dataKey: 'recharge_before',
                customRender: (value, allValues) => <ITDisplayPrice value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 50 + (totalsOrderTableData.totals.recharge_before.toFixed(decimals).length * 8)
            },
        )
    }
    if (totalsOrderTableData.totals.vatMoney2) {
        beforeTotalColumns = [
            {
                label: <OrderSingleHeaderRR transKey='recharge' translation='Recargo' />,
                dataKey: 'taxUsed2',
                customRender: (value) => <ITDisplayVat {...{ value }} />,
                width: 80
            },
            {
                label: <OrderSingleHeaderRR transKey='rechargeImp' translation='Imp. Recargo' />,
                dataKey: 'vatMoney2',
                customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 105 + (totalsOrderTableData.totals.vatMoney2.toFixed(decimals).length * 1.5)
            }
        ]
    }
    const columns: ComponentRowRenderSchema<FooterTotalsResult['groupByAccount']> = [
        ...firstColumns,
        {
            label: <OrderSingleHeaderRR transKey='subtotal' translation='Subtotal' />,
            dataKey: 'subtotal',
            customRender: (value, allValues) => value === 0 ? <NullComponent /> : <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 50 + (totalsOrderTableData.totals.subtotal.toFixed(decimals).length * 7.5)
        },
        ...beforeSubtotalAfterColumns,
        {
            label: <OrderSingleHeaderRR transKey='totalWithoutVat' translation='Base imponible' />,
            dataKey: 'subTotalAfter',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 115 + (totalsOrderTableData.totals.subTotalAfter.toFixed(decimals).length * 2)
        },
        {
            label: <OrderSingleHeaderRR transKey='vat' translation='Impuesto' />,
            dataKey: 'taxUsed',
            customRender: (value) => <ITDisplayVat {...{ value }} />,
            width: 85
        },
        {
            label: <OrderSingleHeaderRR transKey='totalVat' translation='Total Impuestos' />,
            dataKey: 'vatMoney',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 117 + (totalsOrderTableData.totals.vatMoney.toFixed(decimals).length * 2)
        },
        ...beforeTotalColumns,
        {
            label: <OrderSingleHeaderRR transKey='total' translation='Total' />,
            dataKey: 'total',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 75 + (totalsOrderTableData.totals.total.toFixed(decimals).length * 5.5),
            className: 'mr-30'
        },
    ]
    const { columnWidth, ref } = useRowRendererFooterOrderTotalLogic({columns})
    return (
        <div className='overflow-x-auto flex flex-col flex-auto pt-8 row_renderer_totals_parent mt-5 ' ref={ref}>
            <ComponentRowRender columns={columns} data={{ ...myData }} />
            <div className='w-full input_table_footer_total flex'>
                <CRRBody columns={columns} data={[totalsOrderTableData.totals]} defaultColumnWidth={columnWidth} />
            </div>
        </div>)
}

interface RowRendererFooterOrderTotalLogicProps {
    columns: ComponentRowRenderSchema<any>
}

const useRowRendererFooterOrderTotalLogic = ({ columns }: RowRendererFooterOrderTotalLogicProps) => {
    const ref = useRef<any>(null)
    const width = ref.current?.offsetWidth
    const current = ref.current
    useEffect(() => {
        if (current) {
            current.scrollLeft = current.scrollLeftMax
        }
    }, [current])
    const { columnWidth } = useMemo(() => calculateColumnWidth(width || 0, columns), [width, columns])
    return { columnWidth, ref }
}

interface OrderSingleHeaderRRProps {
    transKey: string
    translation: string
    className?: string
}

const OrderSingleHeaderRR: React.FC<OrderSingleHeaderRRProps> = ({ transKey, translation, className }) => {
    return (<span className={'medium16 ' + (className || '')}><TwinTrans transKey={transKey}>{translation}</TwinTrans></span>)
}

export type FooterOrderTotalNewProps = & RowRendererTotalsFullProps & OnChangeOrderTableLogicProps & {
    setOpenModal: ITLayoutTableModalOpenSetTy
    headerData: TwinDictionary
    hideNotes: boolean | undefined
    hideLeftFooter: boolean | undefined
    userPermissions: UserPermissionsSingle
    orderStatusDict: TwinDictionary
    orderStatus: any
    orderHeaderURLs: OrderHeaderURLs
    OrderId: any
    OrderFinancialRows: any
    skipEdit: boolean
    modelId: string
    isReadOnly?: boolean
    costs: TwinDictionary
    FooterOrderLeftConfigComponent: React.FC<FooterConfigShippingComponentBaseProps>
    hideFinancialRows?: boolean
 }

export const FooterOrderTotalNew: React.FC<FooterOrderTotalNewProps> = ({ headerDataCalculate, costs, setOpenModal, headerData, hideLeftFooter, ...rest }) => {
    return (
        <div className='flex justify-between mt-20 gap-20 px-24 pb-24 input_table_footer_footer_new'>
            {!hideLeftFooter ? <FooterOrderLeftComponent {...{ setOpenModal, headerData, ...rest }} /> : null}
            <FooterOrderRightComponent {...{ headerData, headerDataCalculate, setOpenModal, costs, hideLeftFooter, ...rest}} />
        </div>
    )
}

const footerOrderTotalDispatch = {
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}
export type ReduxFooterOrderTotal = ConnectedProps<typeof FooterOrderTotalConnect>
const mapFooterOrderTotalConnector = (state: AllReduxPayloads) => ({ productTypes: state.productTypes })
const footerOrderTotalConnect = connect(mapFooterOrderTotalConnector, footerOrderTotalDispatch)
const FooterOrderTotalLoading = withLoading(FooterOrderTotal, [{ fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const FooterOrderTotalConnect = footerOrderTotalConnect(FooterOrderTotalLoading)

export default FooterOrderTotalConnect